module.exports = __webpack_public_path__ + "media/images/ui__infoBoxSmall--dark-1d6c67410d9ddf0f95d09b4061eea0b4.png";